export default __webpack_public_path__ + "static/media/announcement_5.f6908b16.png";